import { isDarkTheme } from '../services/functions/Functions';

const getThemedClassname = (className) => {
  if (isDarkTheme()) return `${className}-dark`;
  return className;
};

export default getThemedClassname;
